import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '@/views/HomePage.vue';
import PrivacyPolicyPage from '@/views/PrivacyPolicyPage.vue';
import TermsOfServicePage from '@/views/TermsOfServicePage.vue';
import FAQPage from '@/views/FAQPage.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage,
    meta: { title: 'Devolysis - Digital Solutions & AI Automation' }
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicyPage,
    meta: { title: 'Privacy Policy - Devolysis' }
  },
  {
    path: '/terms-of-service',
    name: 'TermsOfService',
    component: TermsOfServicePage,
    meta: { title: 'Terms of Service - Devolysis' }
  },
  {
    path: '/faq',
    name: 'FAQ',
    component: FAQPage,
    meta: { title: 'FAQ - Devolysis' }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      // Support hash navigation on home page
      return { el: to.hash, behavior: 'smooth' };
    }
    return { top: 0, behavior: 'smooth' };
  }
});

// Update page title on navigation
router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'Devolysis';
  next();
});

export default router;
